import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach token from localStorage as a fallback for cross-origin contexts
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("titan_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatGHS(amount) {
  return new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
    maximumFractionDigits: 0,
  }).format(amount);
}

/**
 * Strip a model-year token from a car name for customer-facing display.
 * Years in the DB exist so we can fetch correct stock photos and so admins
 * can disambiguate inventory (e.g. Land Cruiser 2020 vs 2022 GX.R vs 2023);
 * customers don't need to see them.
 *
 * Examples:
 *   "Camry 2018"           -> "Camry"
 *   "3 (2018)"             -> "3"
 *   "Land Cruiser 2022 GX.R" -> "Land Cruiser GX.R"
 *   "Highlander"           -> "Highlander"
 */
export function stripYear(name) {
  if (!name) return name;
  return String(name)
    // remove " (YYYY)" or " (YYYY & YYYY)" parenthetical
    .replace(/\s*\(\s*(?:19|20)\d{2}(?:\s*[&\-/,]\s*(?:19|20)\d{2})*\s*\)/g, "")
    // remove a standalone 4-digit year token (1900-2099) with surrounding whitespace
    .replace(/\s+(?:19|20)\d{2}(?=\s|$)/g, "")
    .replace(/\s{2,}/g, " ")
    .trim();
}

/**
 * Public-facing full car name (brand + model, no year).
 */
export function formatCarName(car) {
  if (!car) return "";
  return `${car.brand || ""} ${stripYear(car.name || "")}`.trim();
}
